import { Button, HStack, Modal, Text, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Service } from '@genial/services';
import { Modal as NativeModal } from 'native-base';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { customerSuitabilityMismatchQuery } from '../../../../../store/customer/selector';
import {
  advisorIdToApisSelector,
  partnerIdToApisSelector,
} from '../../../../../store/master/selector';

export interface ClientWithMismatchedSuitabilityModalProps {
  accountNumber: number;
}

export const ClientWithMismatchedSuitabilityModal: React.FC<
  ClientWithMismatchedSuitabilityModalProps
> = ({ accountNumber }) => {
  const advisorSelected = useRecoilValue(advisorIdToApisSelector);
  const partnerSelected = useRecoilValue(partnerIdToApisSelector);

  const [visible, setVisible] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const { data } = useRecoilQuery(customerSuitabilityMismatchQuery({ accountNumber }), {
    cachePolicy: 'no-cache',
  });

  const handleClose = () => {
    setVisible(false);
  };

  const handleAlreadyNotified = () => {
    setIsUpdating(true);
    Service.Customer.V3.patchRiskWalletByOutOfComplianceNotificationsAccountNumber({
      accountNumber,
      screenName: 'customerDetail',
      advisorId: advisorSelected,
      partnerId: partnerSelected,
    }).finally(() => {
      setVisible(false);
      setIsUpdating(false);
    });
  };

  useEffect(() => {
    if (data?.isMismatchedAndShouldNotify) {
      setVisible(true);
    }
  }, [data]);

  if (!visible) {
    return null;
  }

  return (
    <Modal isOpen={true} testId="suitability-exceeded-details">
      <NativeModal.Content
        alignItems="center"
        w="full"
        maxW={{ base: 'full', lg: '440px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}
        borderRadius={BoxBorder.heavy}>
        <VStack w="full" px="inline.xxs" py="inline.xs" space="stack.xxxs">
          <VStack w="full" px="inline.xxxs" space="stack.xxxs">
            <Text variant="semibold" color="neutral.black" textAlign="center" fontSize="lg">
              Cliente desenquadrado do perfil
            </Text>

            <Text color="bulletrisk.medium" textAlign="center">
              Identificamos que a carteira do cliente está desenquadrada do perfil de risco. É
              necessário avisar o cliente e avaliar possíveis ajustes.
            </Text>

            <HStack space="stack.xxxs">
              <Button
                mt="stack.xxxs"
                flex={1}
                borderRadius="full"
                variant="secondary"
                onPress={handleClose}
                _text={{
                  fontFamily: Typography['fontfamily.base.semibold'],
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                }}>
                Voltar
              </Button>
              <Button
                mt="stack.xxxs"
                flex={1}
                borderRadius="full"
                variant="primary"
                onPress={handleAlreadyNotified}
                isLoading={isUpdating}
                spinnerPlacement="end"
                _text={{
                  fontFamily: Typography['fontfamily.base.semibold'],
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                }}>
                Já avisei o cliente
              </Button>
            </HStack>
          </VStack>
        </VStack>
      </NativeModal.Content>
    </Modal>
  );
};
